import {ExportIcon, Icon} from 'evergreen-ui';
import {ProviderPortalFeatureFlag, useFeatureFlag} from 'featureflag';

type ExportButtonProps = {
    onClick?: () => void;
    disabled?: boolean;
    minWidth?: string;
}

export const ExportButton = ({onClick, disabled = false, minWidth = '7rem'}: ExportButtonProps) => {
    const isExportDisabled = useFeatureFlag(ProviderPortalFeatureFlag.TDTL_9900_IS_EXPORT_DISABLED);
    if (isExportDisabled) {
        return null;
    }
    return (
        <button
            className={`
                text-white bg-teal-600 border-2 border-teal-600
                hover:text-teal-600 hover:bg-white hover:border-teal-600
                ${disabled ? "pointer-events-none select-none opacity-50" : ""}
                focus:outline-none
                rounded-md
                w-full
                font-semibold
                p-2`}
            type="button"
            onClick={onClick}
            style={{minWidth}}
        >
            <span className="flex items-center justify-center gap-2">
                Export
                <Icon icon={ExportIcon} size={14}/>
            </span>
        </button>
    );
}
